import axios from "axios";
import { __constants } from "../../constants";
import { getUsersByConceirge } from "../Concierge";
import { queryGenerator } from "./common";
const BASE_URL = process.env.REACT_APP_SERVER_URL;

export const getSeekersListing = async (param) => {
    try {
        const limit = param.limit || __constants.listingLimit;
        if (param.conceirgeId) {
            const response = await getUsersByConceirge(`limit=${limit}${queryGenerator(param)}`, "Seeker", param.conceirgeId)
            return response;
        } else {
            const config = {
                method: 'GET',
                url: BASE_URL + `/v1/admin/user-management/seekers?limit=${limit}${queryGenerator(param)}`,
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
                },
            };
            const response = await axios(config);
            return response;
        }
    } catch (err) {
        console.error("Error in getSeekersListing >> ", err.message);
        return err.response
    }
}

export const getSeekerProfileController = async (id) => {
    try {
        
        const config = {
            method: 'GET',
            url: BASE_URL + `/v1/admin/user-management/seeker/${id}`,
            headers: {
                'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
            },
        };
        const response = await axios(config);
        return response;
    } catch (err) {
        console.error("Error in getSeekerProfileController >> ", err.message);
        return err.response
    }
}

export const editSeeker = async (data, role, _id) => {
    try {
        const config = {
            method: 'PUT',
            url: BASE_URL + "/v1/admin/user-management/" + role + "/" + _id,
            headers: {
                'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
            },
            data
        };
        const response = await axios(config);
        return response;
    } catch (err) {
        return err.response
    }
}
